import $ from 'jquery';

const defaults = {
  test: 0,
};

export default class Timeline {
  constructor(element, options) {
    this.element = element;
    this.$element = $(this.element);
    this.settings = { ...defaults, ...options };
    this.wrapContent();
    this.addVerticalTimeline();
    this.sortViewsRows();
    this.repositionViewsRows();
    this.createNavigation();
    this.menuPosition();
    this.linkActive();
  }

  addVerticalTimeline() {
    const viewContent = document.querySelector('.timeline .view-content');
    const verticalTimeline = document.createElement('div');
    verticalTimeline.classList.add('timeline-vertical');
    viewContent.appendChild(verticalTimeline);
  }

  wrapContent() {
    // Get all the .node-inner elements
    const nodeInners = document.querySelectorAll('.timeline .node-inner');

    // Iterate through each .node-inner element
    nodeInners.forEach((nodeInner) => {
      // Get the .node-header, .node-content, and .node-links elements within the .node-inner
      const nodeHeader = nodeInner.querySelector('.node-header');
      const nodeContent = nodeInner.querySelector('.node-content');
      const nodeLinks = nodeInner.querySelector('.node-links');

      // Create a new div to wrap the elements
      const wrapperDiv = document.createElement('div');
      wrapperDiv.classList.add('content-wrapper');

      // Append the targeted elements to the wrapper div
      if (nodeHeader) {
        wrapperDiv.appendChild(nodeHeader);
      }
      if (nodeContent) {
        wrapperDiv.appendChild(nodeContent);
      }
      if (nodeLinks) {
        wrapperDiv.appendChild(nodeLinks);
      }

      // Append the wrapper div back to the .node-inner element
      nodeInner.appendChild(wrapperDiv);
    });
  }

  sortViewsRows() {
    // Get all the .views-row elements
    const viewsRows = document.querySelectorAll('.timeline .views-row');

    // Create an object to store references to year divs
    const yearDivs = {};

    // Iterate through each .views-row element
    viewsRows.forEach((row) => {
      // Get the year from the post-type span
      const year = row.querySelector('.post-type').textContent.trim();

      // Create a div for the year if it doesn't exist
      if (!yearDivs[year]) {
        const yearDiv = document.createElement('div');
        yearDiv.classList.add('year-container');
        yearDiv.setAttribute('id', `era-${year}`);

        // Create a title div for the year
        const titleDiv = document.createElement('div');
        titleDiv.classList.add('era-title');

        // Wrap the title with an h2 tag
        const titleHeading = document.createElement('h2');
        titleHeading.textContent = year;
        titleDiv.appendChild(titleHeading);

        yearDiv.appendChild(titleDiv);
        yearDivs[year] = {
          div: yearDiv,
          rows: [], // Array to store rows for this year
        };
      }

      // Store the .views-row into the corresponding year div
      yearDivs[year].rows.push(row);
    });

    // Append the year divs to the .view-content div in sorted order
    const viewContent = document.querySelector('.timeline .view-content');

    // Sort the keys of yearDivs as numbers
    const sortedYears = Object.keys(yearDivs).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));

    // Append year divs to viewContent in sorted order
    sortedYears.forEach((year) => {
      // Sort the rows for this year based on the year mentioned in the h2 title
      yearDivs[year].rows.sort((a, b) => {
        const yearA = parseInt(a.querySelector('h2.title').textContent.trim(), 10);
        const yearB = parseInt(b.querySelector('h2.title').textContent.trim(), 10);
        return yearA - yearB;
      });

      // Append sorted rows to the yearDiv
      yearDivs[year].rows.forEach((row) => {
        yearDivs[year].div.appendChild(row);
      });

      // Append sorted yearDiv to viewContent
      viewContent.appendChild(yearDivs[year].div);
    });
  }

  repositionViewsRows() {
    // After all elements are repositioned, add the class to every second .views-row
    const repositionedViewsRows = document.querySelectorAll('.timeline .views-row');
    repositionedViewsRows.forEach((row, index) => {
      if (index % 2 === 1) {
        row.classList.add('row-reverse');
      }
    });
  }

  createNavigation() {
    // Get all .year-container ids
    const yearContainers = document.querySelectorAll('.year-container');
    const viewContent = document.querySelector('.page-top');

    // Create div in view-content with links to ids
    const timelineNavigation = document.createElement('div');
    timelineNavigation.classList.add('timeline-navigation');

    // Create navigation-links div
    const navigationLinks = document.createElement('div');
    navigationLinks.classList.add('navigation-links');
    timelineNavigation.appendChild(navigationLinks);


    yearContainers.forEach((container) => {
      const id = container.getAttribute('id');
      const link = document.createElement('a');

      link.href = `#${id}`;
      link.textContent = id.replace('era-', '');
      navigationLinks.appendChild(link);
    });

    viewContent.appendChild(timelineNavigation);
  }

  menuPosition() {
    const customMenu = document.querySelector('.timeline-navigation');
    const pageHeader = document.querySelector('.page-header');
    const header = document.querySelector('.header');
    let pageHeaderHeight = header.getBoundingClientRect().height;
    const timeline = document.querySelector('.timeline');

    let contentTop = customMenu.getBoundingClientRect().top + window.scrollY
      - pageHeaderHeight;

    function updateValues() {
      pageHeaderHeight = header.getBoundingClientRect().height;
      if (customMenu.classList.contains('active')) {
        customMenu.classList.remove('active');
        contentTop = customMenu.getBoundingClientRect().top + window.scrollY - pageHeaderHeight
        - pageHeaderHeight;
        customMenu.classList.add('active');
      } else {
        contentTop = customMenu.getBoundingClientRect().top + window.scrollY - pageHeaderHeight;
      }
    }

    function handleScroll() {
      const pageHeaderActive = pageHeader.classList.contains('not-top') && pageHeader.classList.contains('locked');
      const scrollPosition = window.scrollY;
      pageHeaderHeight = header.getBoundingClientRect().height;

      if (scrollPosition >= contentTop) {
        customMenu.classList.add('active');
        timeline.classList.add('active');

        if (pageHeaderActive && window.innerWidth < 1025) {
          const headerHeight = pageHeaderHeight;
          customMenu.style.top = `${headerHeight}px`;
        } else if (window.innerWidth >= 1025) {
          const headerHeight = pageHeaderHeight;
          customMenu.style.top = `${headerHeight}px`;
        } else {
          customMenu.style.top = '';
        }
      } else {
        customMenu.classList.remove('active');
        timeline.classList.remove('active');
        customMenu.style.top = '';
      }
    }

    window.addEventListener('resize', updateValues);
    window.addEventListener('scroll', handleScroll);
  }

  linkActive() {
    const links = document.querySelectorAll('.timeline-navigation a');
    const pageHeader = document.querySelector('.header');
    const pageCustomMenu = document.querySelector('.timeline-navigation');
    let pageHeaderHeight = pageHeader.offsetHeight;
    let pageCustomMenuHeight = pageCustomMenu.offsetHeight;

    function getSectionTop(section) {
      const rect = section.getBoundingClientRect();
      return rect.top + window.scrollY - pageHeaderHeight - pageCustomMenuHeight - 15;
    }

    function debounce(func, delay) {
      let timeoutId;
      return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
      };
    }

    const delayedScrollIntoView = debounce((link) => {
      link.scrollIntoView({ behavior: 'smooth' });
    }, 50);

    function activateLinks() {
      const scrollPosition = window.scrollY;

      links.forEach((link) => {
        const sectionId = link.hash;
        const section = document.querySelector(`div${sectionId}`);

        if (section) {
          const sectionTop = getSectionTop(section);

          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + section.offsetHeight) {
            link.classList.add('active');
            delayedScrollIntoView(link);
          } else {
            link.classList.remove('active');
          }
        }
      });
    }

    window.addEventListener('resize', () => {
      pageHeaderHeight = pageHeader.offsetHeight;
      pageCustomMenuHeight = pageCustomMenu.offsetHeight;
    });
    window.addEventListener('scroll', activateLinks);
  }
}
